import React, { useState } from 'react';
import { Form, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import AuthLayout from '../components/auth/AuthLayout';
import '../components/css/ForgotPasswordPage.css';
import { forgotPasswordOtpApi, resetPasswordApi, verifyForgotPasswordOtpApi } from '../services/api';
import Swal from 'sweetalert2';
import ForgotPasswordFormFields from '../components/auth/ForgotPasswordFormFields';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setMessage('');
    setIsError(false);
    setLoading(true);

    try {
      const { data } = await forgotPasswordOtpApi({ email });
      setMessage(data.message || 'OTP sent successfully.');
      setOtpSent(true);
      setIsError(false);
    } catch (err) {
      setMessage(err.response?.data?.message || 'Failed to send OTP.');
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    try {
      await resetPasswordApi({ email, otp, password });
      setIsError(false);

      Swal.fire({
        icon: 'success',
        title: 'Password Reset Successful',
        text: 'Redirecting to Login Page...',
        timer: 3000,
        showConfirmButton: false
      });

      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      setMessage(err.response?.data?.message || "Failed to reset password");
      setIsError(true);
    }
  };

  const handleVerifyOtp = async () => {
    try {
      await verifyForgotPasswordOtpApi({ email, otp });
      setIsError(false);

      Swal.fire({
        icon: 'success',
        title: 'OTP Verified',
        text: 'Please change your password',
        timer: 2000,
        showConfirmButton: false
      });

      setTimeout(() => {
        setMessage('');
        setOtpVerified(true);
      }, 2000);
    } catch (err) {
      setMessage(err.response?.data?.message || "Invalid OTP");
      setIsError(true);
    }
  };

  return (
    <AuthLayout
      pageTitle="Forgot Password - BOOKMYAUDITION"
      metaDescription="Reset your BOOKMYAUDITION account password."
      sidebarTitle="FORGOT PASSWORD"
      sidebarText="Don't Worry. We've got you back."
      sidebarLink="/register"
      sidebarLinkText="Register"
      className="forgot-password-auth-layout" 
    >
      <Form onSubmit={handleForgotPassword}>
        {message && <Alert variant={isError ? "danger" : "success"} className="py-2 small">{message}</Alert>}
        
        <ForgotPasswordFormFields
          email={email}
          setEmail={setEmail}
          otpSent={otpSent}
          otpVerified={otpVerified}
          otp={otp}
          setOtp={setOtp}
          password={password}
          setPassword={setPassword}
          loading={loading}
          handleVerifyOtp={handleVerifyOtp}
          handleResetPassword={handleResetPassword}
        />
      
        <p className="auth-footer-link text-secondary text-center mt-4 mb-0 small">
          Already have an account? <Link to="/login" className="text-red text-decoration-none fw-bold">Sign in</Link>
        </p>
      </Form>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;